import React, { useState } from 'react';
import img from 'Common/img/WireframesGlobal Nav Logo.svg';
import AppService from 'Global/AppService';
import NavLeftOptions from './NavLeftOptions';
import NavRightOptions from './NavRightOptions';



const NavHeader = () => {

    const [toggleDropdown, setToggleDropdown] = useState(false);


            return (
            <nav data-testid="main-nav-bar" className="navbar navbar-expand-md navbar-light bg-beckman-grey10">
                <a className="navbar-brand nav-border-right">
                    <img src={img} className="bec-logo" alt="Beckman Coulter" />
                </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <NavLeftOptions></NavLeftOptions>
                    <NavRightOptions></NavRightOptions>
                </div>
            </nav>
        )
}

export {
    NavHeader
}